module.exports = __webpack_public_path__ + "img/material-svg-icons.557efc64.svg";